// Get version from package.json
// eslint-disable-next-line @typescript-eslint/no-var-requires
const packageJson = require('../../package.json');

const APP_VERSION = packageJson.version || '-1.0.0';

export default APP_VERSION;
